import Immutable from 'immutable';
import {
  APPEND_FEED_ITEMS_PER_BLOCK,
  SET_FEED_ITEMS_PER_BLOCK,
} from './actions';
import {
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
  BLOCK_FEED_DATA_LOAD_MORE_SUCCESS,
  BLOCK_FEED_DATA_FETCH_SUCCESS,
} from '../Feeds/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';
import { ActionTypes } from '../Posts/actions';

const BY_BLOCK_ID = 'byBlockId';
const FIRST_LOADED_POST_ITEM = 'firstLoadedItemId';

const DEFAULT_STATE = Immutable.fromJS({
  [BY_BLOCK_ID]: {},
  [FIRST_LOADED_POST_ITEM]: null,
});

const EMPTY_LIST = Immutable.List();

export function FeedItems(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_BLOCK_FEED_DATA:
    case BLOCK_FEED_DATA_FETCH_SUCCESS:
    case SET_FEED_ITEMS_PER_BLOCK: {
      const { blockID, feedItems } = action;
      return state.setIn([BY_BLOCK_ID, blockID], Immutable.fromJS(feedItems));
    }
    case PREPEND_BLOCK_FEED_DATA: {
      const { blockID, feedItems } = action;
      const currFeedItems = state.getIn([BY_BLOCK_ID, blockID], EMPTY_LIST);
      return state.setIn(
        [BY_BLOCK_ID, blockID],
        Immutable.fromJS(feedItems).concat(currFeedItems)
      );
    }
    case APPEND_BLOCK_FEED_DATA:
    case APPEND_FEED_ITEMS_PER_BLOCK:
    case BLOCK_FEED_DATA_LOAD_MORE_SUCCESS: {
      const { blockID, feedItems } = action;
      const currFeedItems = state.getIn([BY_BLOCK_ID, blockID], EMPTY_LIST);
      const firstItemId = feedItems[0] ? feedItems[0].id : null;

      return state
        .setIn(
          [BY_BLOCK_ID, blockID],
          currFeedItems.concat(Immutable.fromJS(feedItems))
        )
        .set(FIRST_LOADED_POST_ITEM, firstItemId);
    }
    case ActionTypes.POST_REMOVED: {
      const { postId } = action;
      const updatedState = state;
      const feedItemsByBlockId = state.get(BY_BLOCK_ID).map((fisByBlock) => {
        const fis = fisByBlock.filter((fi) => {
          return !(
            fi.get('items').get(0).getIn(['object', 'id']) === postId || // remove post feeditem
            fi.get('items').get(0).getIn(['context', 'id']) === postId
          ); // remove comment thread related to that post
        });
        return fis;
      });
      return updatedState.set(BY_BLOCK_ID, feedItemsByBlockId);
    }
    case FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS: {
      const { cohortPath, feedItems } = action;
      return state.setIn(
        ['byCohortPath', cohortPath],
        Immutable.fromJS(feedItems)
      );
    }
    case FEED_DATA_LOAD_MORE_SUCCESS: {
      const { cohortPath, feedItems } = action;
      if (!!feedItems && feedItems.length > 0) {
        const currFeedItems = state.getIn(
          ['byCohortPath', cohortPath],
          Immutable.List()
        );
        return state.setIn(
          ['byCohortPath', cohortPath],
          currFeedItems.concat(Immutable.fromJS(feedItems))
        );
      } else {
        return state;
      }
    }
    case LOGOUT_SUCCESS: {
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
}
